import { useState } from 'react';
import SmokeDetectorList from './SmokeDetectorList';
import LocationList from './LocationList';
import RecipientUserList from './RecipientUserList';
import NotificationsLog from './NotificationsLog';
import AlarmsLog from './AlarmsLog';
import UserList from './UserList';
import DataHealthTab from './DataHealthTab';
import VocShipmentsTab from './VocShipmentsTab';
import GatewayAlertsTab from './GatewayAlertsTab';

const AdminDashboard = ({ isAdmin }) => {
  const [view, setView] = useState('detectors');

  const navButton = {
    backgroundColor: '#6c757d',
    color: '#fff',
    border: 'none',
    padding: '0.5rem 1rem',
    marginLeft: '0.5rem',
    borderRadius: '4px',
    cursor: 'pointer'
  };

  const navButtonActive = {
    ...navButton,
    backgroundColor: '#007bff'
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', backgroundColor: '#f4f6f8', minHeight: '100vh' }}>
      <header style={{
        backgroundColor: '#343a40',
        color: '#fff',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <h1 style={{ margin: 0, fontSize: '1.8rem' }}>🛠 Panel de Administración</h1>
        <nav>
          <button onClick={() => setView('detectors')} style={view === 'detectors' ? navButtonActive : navButton}>
            🔥 Detectores
          </button>
          <button onClick={() => setView('locations')} style={view === 'locations' ? navButtonActive : navButton}>
            📍 Ubicaciones
          </button>
          <button onClick={() => setView('recipients')} style={view === 'recipients' ? navButtonActive : navButton}>
            📇 Destinatarios
          </button>
          <button onClick={() => setView('notifications')} style={view === 'notifications' ? navButtonActive : navButton}>
            📋 Notificaciones
          </button>
          <button onClick={() => setView('alarms')} style={view === 'alarms' ? navButtonActive : navButton}>
            🚨 Alarmas
          </button>
          {isAdmin && (
            <button onClick={() => setView('users')} style={view === 'users' ? navButtonActive : navButton}>
              👥 Usuarios
            </button>
          )}
          {isAdmin && (
            <button onClick={() => setView('data')} style={view === 'data' ? navButtonActive : navButton}>
              📊 Salud Detectores
            </button>
          )}
          {isAdmin && (
            <button onClick={() => setView('voc')} style={view === 'voc' ? navButtonActive : navButton}>
              🧪 VOCs y envíos
            </button>
          )}
          {isAdmin && (
            <button onClick={() => setView('gateways')} style={view === 'gateways' ? navButtonActive : navButton}>
              📡 Gateways
            </button>
          )}
        </nav>
      </header>

      <main style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
        {view === 'detectors' && <SmokeDetectorList />}

        {view === 'locations' && isAdmin && <LocationList />}

        {view === 'locations' && !isAdmin && (
          <div style={{
            backgroundColor: '#fff3cd',
            color: '#856404',
            padding: '1rem',
            borderRadius: '6px',
            border: '1px solid #ffeeba',
            textAlign: 'center'
          }}>
            ⚠️ No tienes permisos para gestionar ubicaciones.
          </div>
        )}

        {view === 'recipients' && <RecipientUserList />}

        {view === 'notifications' && <NotificationsLog />}

        {view === 'alarms' && <AlarmsLog />}

        {view === 'users' && isAdmin && <UserList />}

        {view === 'data' && isAdmin && <DataHealthTab />}

        {view === 'voc' && isAdmin && <VocShipmentsTab />}

        {view === 'gateways' && isAdmin && <GatewayAlertsTab />}
      </main>
    </div>
  );
};

export default AdminDashboard;
